import { Component, OnInit, Input } from '@angular/core';
import { Product } from '../interfaces/product.interface';
import { PlanAttributes, SummaryView } from '../interfaces/plan-attributes.interface';
import { PlanDetailsService } from './plan-details.service';
import { PlanDetailsRenderableCategory } from './types/plan-details.types';
import { Subscription } from 'rxjs';
import { LINE_OF_BUSINESS_ENUM } from '@ptl/account-management';


@Component({
    selector: 'app-plan-details',
    templateUrl: './plan-details.component.html',
    styleUrls: ['./plan-details.component.scss'],
    standalone: false
})
export class PlanDetailsComponent implements OnInit {

  @Input() enrollStartUrl: string;
  @Input() specialEnrollmentUrl: string;
  @Input() wholeHealthBalanceEnrollStartUrl: string;
  @Input() viewPlansUrl: string;
  @Input() recommendedPlansUrl: string;
  @Input() market: string;
  @Input() plansFullData: Product<PlanAttributes, SummaryView>[];
  @Input() plans: PlanDetailsRenderableCategory[];
  @Input() enrollmentFlow: string;

  iconographyDetails: PlanDetailsRenderableCategory;

  onDrawerChange: Subscription;

  isIndividualMarket: boolean;

  constructor(
    private planDetailsService: PlanDetailsService
  ) { }

  async ngOnInit() {  
    this.onDrawerChange = this.planDetailsService.drawerChanged$.subscribe(() => {
      document.getElementsByTagName('sxe-plan-and-drx-tabs')[0]?.scrollIntoView();
    });

    this.isIndividualMarket = this.market?.toUpperCase() === LINE_OF_BUSINESS_ENUM.INDIVIDUAL;
  }

  onDestroy() {
    if (this.onDrawerChange) { this.onDrawerChange.unsubscribe(); }
  }
}
